import { createSSRApp } from 'vue';
import appConfig from './app.js';
import { createWebHistory } from 'vue-router';
import store, { registry } from 'Stores';
import createRouter from './routes';
import VueCookies from 'vue-cookies';
import globalMixin from './mixins/globalMixin';

const app = createSSRApp(appConfig);

Object.keys(window.stores || {}).forEach((key) => {
  registry.register(key, window.stores[key]);
});

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {top: 0};
        }
    },
});

app.use(VueCookies);
app.use(router);
app.use(store);
app.mixin(globalMixin);

store.dispatch('contact/initUserType').then(() => {
    app.mount('#app');
});
